import { ArrowRight } from "lucide-react";
import { trackOutbound } from "../lib/track";

const REASSURANCE = "Secure booking is completed through our established Stay Play Explore booking system.";

export function BookingCta({ brk, placement = "break-page", large = true }) {
  const speUrl = `${brk.spe_deep_link}?utm_source=theperfectbreak&utm_medium=referral_site&utm_campaign=tpb_site&utm_content=${brk.slug}`;
  return (
    <div data-testid={`booking-cta-${placement}`}>
      <a
        href={speUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackOutbound({ break_slug: brk.slug, destination_url: brk.spe_deep_link, placement })}
        className={large ? "btn-accent w-full sm:w-auto" : "btn-accent !px-5 !py-2.5"}
        data-testid={`check-dates-book-button-${placement}`}
      >
        Check dates &amp; book <ArrowRight className="h-4 w-4" />
      </a>
      <p className={`${large ? "mt-2 text-xs" : "mt-1.5 max-w-[170px] text-[9px]"} leading-relaxed text-ink-muted`} data-testid={`booking-reassurance-${placement}`}>
        {REASSURANCE}
      </p>
    </div>
  );
}
